/**
 * @param  {Object} state
 * @return {Object}
 */
export const globalError = (state) => {
  return state.error;
};

/**
 * @param  {Object} state
 * @return {Number}
 */
export const globalSuccess = (state) => {
  return state.success;
};

/**
 * @param  {Object} state
 * @return {Boolean}
 */
export const LOADING = (state) => {
  return state.loader;
};
